/**
 * LinkIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const LinkIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M19.491 4.5a5.153 5.153 0 0 0-7.267 0l-2.177 2.176a1.03 1.03 0 0 0 0 1.457 1.03 1.03 0 0 0 1.458 0l2.176-2.176a3.084 3.084 0 1 1 4.363 4.362l-2.177 2.176a1.03 1.03 0 0 0 0 1.458c.196.196.467.299.729.299s.523-.103.728-.3l2.177-2.176c1.999-1.999 1.999-5.259 0-7.267z" />
    <path d="M7.87 14.672a1.02 1.02 0 0 0 .73 1.747c.261 0 .523-.103.728-.299l5.81-5.81a1.03 1.03 0 0 0 0-1.457 1.02 1.02 0 0 0-1.448 0z" />
    <path d="m9.319 19.025 2.176-2.176h-.009a1.03 1.03 0 0 1 1.457 0 1.02 1.02 0 0 1 0 1.447l-2.176 2.177c-1 1-2.317 1.504-3.634 1.504a5.13 5.13 0 0 1-3.634-1.504c-1.999-2.008-1.999-5.268 0-7.268l2.177-2.176a1.032 1.032 0 0 1 1.457 1.457l-2.176 2.177a3.084 3.084 0 1 0 4.362 4.362" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const LinkIcon = makeIcon('LinkIcon', LinkIconSvg)
